import { Form, Formik, FormikHelpers } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal, UpsertKeywords } from "src/app/components";
import { useThematicsOptions } from "src/app/hooks";
import { KeywordsTransport } from "src/app/transports/keywords";
import { KeywordsDTO, KeywordsDTOSchema } from "src/app/types/keywords";
import { apiToFormikErrors } from "src/app/utils/formHelpers";

export interface IUpsertKeywordsModalContainer {
    showModal?: boolean;
    handleClose?(): void;
}

const UpsertKeywordsModalContainer = (props: IUpsertKeywordsModalContainer) => {
    const { showModal = false, handleClose = () => {} } = props;
    const [loading, setLoading] = useState(false);
    const { thematicsOptions, loading: thematicLoading } = useThematicsOptions();
    const [disableConfirmationmButton, setDisableConfirmationmButton] = useState(true);
    const { formatMessage } = useIntl();

    const handleDisableButton = (disable: boolean) => {
        setDisableConfirmationmButton(() => disable);
    };

    const handleSubmit = async (_values: KeywordsDTO, formikHelpers: FormikHelpers<any>) => {
        await setLoading(true);

        try {
            await KeywordsTransport.save(_values);
            toast.success(formatMessage({ id: "common.notification.success" }));
            setLoading(false);
            handleClose();
        } catch (error: any) {
            setLoading(false);
            if (error?.response?.data?.detail && error?.response?.data?.detail.includes("%")) {
                const responseStrings = error?.response?.data?.detail.split("%");
                toast.error(
                    formatMessage(
                        { id: "common.notification.error.copyscape" },
                        { percent: responseStrings[0], url: responseStrings[1] }
                    )
                );
            } else {
                toast.error(formatMessage({ id: "common.notification.error" }));
            }
            apiToFormikErrors(error?.response, formikHelpers);
        }
        setDisableConfirmationmButton(true);
        setLoading(false);
    };

    return (
        <SimpleModal
            formId="upsertKeywords"
            entityName="Add keywords"
            showModal={showModal}
            handleClose={handleClose}
            disableConfirmation={disableConfirmationmButton}
            loading={loading}
            modalProps={{ size: undefined }}
        >
            <Formik
                initialValues={KeywordsDTOSchema.getDefault()}
                validationSchema={KeywordsDTOSchema}
                onSubmit={(values, formikHelpers: FormikHelpers<object>) =>
                    handleSubmit(values as KeywordsDTO, formikHelpers)
                }
            >
                <Form id="upsertKeywords">
                    <UpsertKeywords
                        isLoading={thematicLoading}
                        thematicsOptions={thematicsOptions}
                        handleDisableButton={handleDisableButton}
                    />
                </Form>
            </Formik>
        </SimpleModal>
    );
};

export default UpsertKeywordsModalContainer;
